import { render, staticRenderFns } from "./QA.vue?vue&type=template&id=193691a8"
import script from "./QA.vue?vue&type=script&lang=js"
export * from "./QA.vue?vue&type=script&lang=js"
import style0 from "./QA.vue?vue&type=style&index=0&id=193691a8&prod&scope=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports